import '../css/dashboard.css';
import '../css/orders.css';
import '../css/order.css';
import useFetch from "../api/useFetch";
import { useState } from 'react';
import Updated from '../static/img/updated.png';
import Loading from './Loading';
import OrderLine from './OrderLine'
import ShipmentForm from './ShipmentForm';
import OrderUpdateForm from './OrderUpdateForm';
import CommentForm from './CommentForm';
import axios from 'axios';
import API_BASE_URL from '../api/config';



const Orders = ({status_filter, notify, search_orders=null}) => {
    const [refresh, setRefresh] = useState(false);
    const [shipmentFormVisible, setShipmentFormVisible] = useState(false)
    const [commentFormVisible, setCommentFormVisible] = useState(false)
    const [page, setPage] = useState(1)
    const [orderUpdateFormVisible, setOrderUpdateFormVisible] = useState(false)
    const { result: fetchedOrders, isLoading: fetchedOrdersLoading, error: fetchedOrdersError } = useFetch('/get_martelle_orders?page=' + page + '&status_filter='+status_filter,[refresh]);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
    const [isConfirmingSent, setIsConfirmingSent] = useState(false);
    const [isCreatingShipments, setIsCreatingShipments] = useState(false);
    
    console.log('search results in Orders.js: ' , search_orders)
    let rawOrders = search_orders ? { items: search_orders, total: search_orders.length } : fetchedOrders
    const ordersLoading = search_orders ? false : fetchedOrdersLoading
    const ordersError = search_orders ? null : fetchedOrdersError

    // Process orders for direct status: sort by latest_shipping_date and group multi orders
    const processOrdersForDisplay = (orders) => {
      if (!orders || !orders.items) return orders;
      
      let processedItems = [...orders.items];
      
      // Sort direct orders by latest_shipping_date (ascending)
      if (status_filter === 'direct') {
        processedItems.sort((a, b) => {
          // Sort by latest_shipping_date for both direct and direct_to_customer_to_send statuses
          if ((a.status === 'direct' || a.status === 'direct_to_customer_to_send') && 
              (b.status === 'direct' || b.status === 'direct_to_customer_to_send')) {
            
            // Primary sort: by latest_shipping_date (ascending)
            const dateComparison = new Date(a.latest_shipping_date) - new Date(b.latest_shipping_date);
            
            // Secondary sort: if dates are the same, sort by order_id (ascending)
            if (dateComparison === 0) {
              return a.order.id - b.order.id;
            }
            
            return dateComparison;
          }
          return 0;
        });
      }
      
      // Group multi orders and mark which ones should show buttons
      const orderGroups = {};
      processedItems.forEach((order, index) => {
        if (order.is_multi && (order.status === 'direct' || order.status === 'direct_to_customer_to_send')) {
          if (!orderGroups[order.order.id]) {
            orderGroups[order.order.id] = [];
          }
          orderGroups[order.order.id].push(index);
        }
      });
      
      // Mark orders with showButtons property
      processedItems = processedItems.map((order, index) => {
        let showButtons = true;
        
        if (order.is_multi && (order.status === 'direct' || order.status === 'direct_to_customer_to_send')) {
          const groupIndexes = orderGroups[order.order.id];
          // Only show buttons on the first order of each group
          showButtons = groupIndexes && groupIndexes[0] === index;
        }
        
        return { ...order, showButtons };
      });
      
      return { ...orders, items: processedItems };
    };

    const orders = processOrdersForDisplay(rawOrders);



  const handleRefresh = () => {
      setRefresh(!refresh)
  }

  const generateShippingLabel = async () => {
    setIsGeneratingPdf(true);
    try {
      const token = localStorage.getItem('accessToken');
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(`${API_BASE_URL}/generate_martelle_shipping_pdf`, {
        headers,
        responseType: 'blob', // Important for handling binary data
      });

      if (response.status === 200) {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        
        // Set filename from response headers if available, otherwise use default
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'etiquette_martelle.pdf';
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/);
          if (filenameMatch) {
            filename = filenameMatch[1];
          }
        }
        
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        
        notify('Étiquette générée et téléchargée avec succès');
      }
    } catch (error) {
      console.error('Error generating shipping label:', error);
      if (error.response && error.response.status === 401) {
        // Handle token refresh if needed
        const refreshToken = localStorage.getItem('refreshToken');
        try {
          const refreshResponse = await axios.post(`${API_BASE_URL}/token/refresh/`, { refresh: refreshToken });
          if (refreshResponse.status === 200) {
            localStorage.setItem('accessToken', refreshResponse.data.access);
            return generateShippingLabel(); // Retry the request
          }
        } catch (refreshError) {
          notify('Erreur d\'authentification', 'error');
        }
      } else {
        notify('Erreur lors de la génération de l\'étiquette', 'error');
      }
    } finally {
      setIsGeneratingPdf(false);
    }
  }

  const confirmAllOrdersSent = async () => {
    setIsConfirmingSent(true);
    try {
      const token = localStorage.getItem('accessToken');
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(`${API_BASE_URL}/mark_martelle_orders_as_sent`, {
        headers,
      });

      if (response.status === 200) {
        notify('Toutes les commandes ont été marquées comme envoyées');
        setRefresh(!refresh); // Refresh the orders list
      }
    } catch (error) {
      console.error('Error confirming orders as sent:', error);
      if (error.response && error.response.status === 401) {
        // Handle token refresh if needed
        const refreshToken = localStorage.getItem('refreshToken');
        try {
          const refreshResponse = await axios.post(`${API_BASE_URL}/token/refresh/`, { refresh: refreshToken });
          if (refreshResponse.status === 200) {
            localStorage.setItem('accessToken', refreshResponse.data.access);
            return confirmAllOrdersSent(); // Retry the request
          }
        } catch (refreshError) {
          notify('Erreur d\'authentification', 'error');
        }
      } else {
        notify('Erreur lors de la confirmation des envois', 'error');
      }
    } finally {
      setIsConfirmingSent(false);
    }
  }

  const createDirectShipments = async () => {
    setIsCreatingShipments(true);
    try {
      const token = localStorage.getItem('accessToken');
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(`${API_BASE_URL}/create_direct_shipments_martelle`, {
        headers,
      });

      if (response.status === 200 || response.status === 202) {
        notify('Envois directs créés avec succès');
        setRefresh(!refresh); // Refresh the orders list
      }
    } catch (error) {
      console.error('Error creating direct shipments:', error);
      if (error.response && error.response.status === 401) {
        // Handle token refresh if needed
        const refreshToken = localStorage.getItem('refreshToken');
        try {
          const refreshResponse = await axios.post(`${API_BASE_URL}/token/refresh/`, { refresh: refreshToken });
          if (refreshResponse.status === 200) {
            localStorage.setItem('accessToken', refreshResponse.data.access);
            return createDirectShipments(); // Retry the request
          }
        } catch (refreshError) {
          notify('Erreur d\'authentification', 'error');
        }
      } else {
        notify('Erreur lors de la création des envois directs', 'error');
      }
    } finally {
      setIsCreatingShipments(false);
    }
  }

  const openShipmentForm = () => {
    setShipmentFormVisible(true);
  };

  const openOrderUpdateForm = () => {
    setOrderUpdateFormVisible(true);
  };
    

  const openCommentForm = () => {
    setCommentFormVisible(true);

  }

  const handleUpdateClick = (orderId) => {
    setSelectedOrderId(orderId);
  };

  const handlePreviousClick = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleNextClick = () => {
    if (page < orders.total / 15){
      setPage(page + 1);}
  };

  const handlePageClick = (pageNumber) => {
    setPage(pageNumber);
  };

  const renderPageNumbers = (pages) => {
    const totalPages = pages;
    const pageNumbers = [];
    const ellipsis = <div>...</div>;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        pageNumbers.push(
          <div
            key={i}
            className={`number${page === i ? " active" : ""}`}
            onClick={() => handlePageClick(i)}
          >
            {i}
          </div>
        );
      } else if (pageNumbers[pageNumbers.length - 1] !== ellipsis) {
        pageNumbers.push(ellipsis);
      }
    }

    return pageNumbers;
  };
   
  return (
    <>
      <div div className="orders">
        <div div className="title"> COMMANDES {status_filter === 'direct' && 'ENVOI DIRECTS'} {status_filter === 'a_envoyer' && 'A ENVOYER'}{status_filter === 'a_saisir' && 'A SAISIR'}{status_filter === 'late' && 'EN RETARD'}{status_filter === 'en_commande' && 'EN ATTENTE'}{status_filter === 'incomplete' && 'INCOMPLETES'}<i className="fas fa-sync" onClick={handleRefresh}></i></div>
        {!ordersLoading &&  orders && orders.total > 0 && status_filter === 'a_envoyer' && <button id="shipment-form-button"  onClick={openShipmentForm} ><i className="fas fa-plane-departure"></i>{`Créer Envoi [Nombre d'ouvrages: ${orders.total_books} | Poids Théorique Actuel: ${orders.items.filter(item => item.status === status_filter).reduce((sum,element) => sum + parseFloat(element['quantity']) * parseFloat(element['product']['weight']), 0).toFixed(1) } kg]`}</button>}
        {!ordersLoading &&  orders && orders.total > 0 && status_filter === 'direct' && orders.items.some(order => order.status === 'direct') && (
          <button 
            id="create-shipments-button" 
            onClick={createDirectShipments} 
            disabled={isCreatingShipments}
          >
            {isCreatingShipments ? (
              <><i className="fas fa-spinner fa-spin"></i> Création en cours...</>
            ) : (
              <><i className="fas fa-shipping-fast"></i> Créer Envois</>
            )}
          </button>
        )}
        {!ordersLoading &&  orders && orders.total > 0 && status_filter === 'direct' && orders.items.some(order => order.status === 'direct_to_customer_to_send') && (
          <>
            <button id="label-generation-button" onClick={generateShippingLabel} disabled={isGeneratingPdf}>
              {isGeneratingPdf ? (
                <><i className="fas fa-spinner fa-spin"></i> Génération en cours...</>
              ) : (
                <><i className="fas fa-tag"></i> Créer Toutes les Étiquettes</>
              )}
            </button>
            <button id="confirm-sent-button" onClick={confirmAllOrdersSent} disabled={isConfirmingSent}>
              {isConfirmingSent ? (
                <><i className="fas fa-spinner fa-spin"></i> Confirmation en cours...</>
              ) : (
                <><i className="fas fa-check-circle"></i> Confirmer envoi de toutes les commandes</>
              )}
            </button>
          </>
        )}
          <div className="table">
            <div className="table-header">
              <div className="date">Date</div>
              <div className="small">Commande</div>
              <div className="product">Nom du Livre</div>
              <div className="order_id">EAN</div>
              <div className="small">Quantité</div>
              <div className="medium">Fournisseur</div>
              <div className="price">Prix TTC</div>
              <div className="medium">Date Envoi Max</div>
              <div className="status">Statut</div>
              <div className="medium">{status_filter === 'a_envoyer' && 'Envoyer'}</div>
            </div>
            <div className="table-body">
              {ordersLoading && <div div className='table-placeholder'><Loading /></div>}
              {ordersError && <div>{ordersError}</div>}
              {!ordersLoading &&  orders && orders.total > 0 && orders.items.map((order) => <OrderLine  id={order.id}  global_order_id = {order.order.id} latest_date={order.latest_shipping_date} is_multi={order.is_multi} order_date={order.creation_date} product_name={order.product.name} ean={order.product.ean} quantity={order.quantity}  status={order.status} supplier={order.suppliers}  price={order.product.ttc_price_dilicom} is_external={order.is_external} label_url={order.label_url} is_stock={order.is_stock} notify={notify} refresh={refresh} setRefresh={setRefresh} openOrderUpdateForm={openOrderUpdateForm} openCommentForm={openCommentForm} onUpdateClick={handleUpdateClick} comment={order.comment} destination_country={order.order.destination_country} showButtons={order.showButtons}/>)}
              {!ordersLoading && orders && orders.total === 0 && <img src={Updated} alt="" width="200px" id='updated'/>}
            </div>
          </div>
        </div>
        {!ordersLoading && orders && orders.total > 15 && status_filter !== 'direct' && (
        <div div className="pagination">
          <div div className="number" onClick={handlePreviousClick}>
            <i className="fas fa-angle-left"></i>
          </div>
          {renderPageNumbers(parseInt(orders.total / 15) + 1)}
          <div div className="number" onClick={handleNextClick}>
            <i className="fas fa-angle-right"></i>
          </div>
        </div>
      )}
        {shipmentFormVisible && (<><ShipmentForm notify = {notify}  visible={shipmentFormVisible} setVisible={setShipmentFormVisible}  setRefresh={setRefresh} refresh={refresh} isMulti={false}/><div className="bg-disabled"></div></>)}
        {orderUpdateFormVisible && (<><OrderUpdateForm notify = {notify}  visible={orderUpdateFormVisible} setVisible={setOrderUpdateFormVisible}  setRefresh={setRefresh} refresh={refresh} isMulti={false} orderId={selectedOrderId}/><div className="bg-disabled"></div></>)}
        {commentFormVisible && (<><CommentForm notify = {notify}  visible={commentFormVisible} setVisible={setCommentFormVisible}  setRefresh={setRefresh} refresh={refresh} isMulti={false} orders={orders.items} orderId={selectedOrderId}/></>)}
    </>
  );  
}

export default Orders